import React from 'react';
import { useAuth } from '../context/AuthContext';
import Button from '../components/Button/Button';
import styles from './LoginPage.module.scss';

function LoginPage() {
  const { login, loading } = useAuth();
  
  if (loading) return <div>Loading…</div>;
  
  return (
    <div className={styles.login}>
      <div className={styles.login__header}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
        <rect width="32" height="32" fill="#040E12" rx="4"/>
        <path fill="#fff" d="M22.9173 11.8163c-1.1503 0-2.0828-.9558-2.0828-2.13476 0-1.17898.9325-2.13473 2.0828-2.13473 1.1502 0 2.0827.95575 2.0827 2.13473 0 1.17896-.9325 2.13476-2.0827 2.13476Zm-6.6408-3.54683c-1.1503 0-2.0827-.95576-2.0827-2.13474C14.1938 4.95575 15.1262 4 16.2765 4c1.1502 0 2.0827.95575 2.0827 2.13473 0 1.17898-.9325 2.13474-2.0827 2.13474ZM15.5392 28c-1.1503 0-2.0827-.9558-2.0827-2.1347 0-1.179.9324-2.1348 2.0827-2.1348s2.0827.9558 2.0827 2.1348c0 1.1789-.9324 2.1347-2.0827 2.1347ZM9.45137 12.6457c-1.15026 0-2.08273-.9558-2.08273-2.1348 0-1.17894.93247-2.1347 2.08273-2.1347 1.15023 0 2.08273.95576 2.08273 2.1347 0 1.179-.9325 2.1348-2.08273 2.1348Zm6.45643 5.0621c-1.1502 0-2.0827-.9558-2.0827-2.1347 0-1.179.9325-2.1348 2.0827-2.1348 1.1503 0 2.0828.9558 2.0828 2.1348 0 1.1789-.9325 2.1347-2.0828 2.1347Zm6.0879 5.489c-1.1503 0-2.0828-.9557-2.0828-2.1347s.9325-2.1347 2.0828-2.1347c1.1502 0 2.0827.9557 2.0827 2.1347s-.9325 2.1347-2.0827 2.1347ZM9.08273 24.2922C7.93247 24.2922 7 23.3365 7 22.1575s.93247-2.1348 2.08273-2.1348c1.15027 0 2.08277.9558 2.08277 2.1348 0 1.179-.9325 2.1347-2.08277 2.1347Z"/>
      </svg>
      <div className={styles.login__wordmark}>
      Sk<span>i</span>ma
      </div>
      </div>

      <Button 
        type="primary" 
        onClick={login} 
      >
        Sign in with Google
      </Button>
      <p className={styles.login__text}>
        Only @okaybueno.com accounts are allowed.
      </p>
    </div>
  );
}

export default LoginPage; 